var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "icon3-b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94A3B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "24.537%",
    x2: "50%",
    y2: "99.142%",
    id: "icon3-c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334155",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334155",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icon3-a",
    d: "M16 0l16 32-16-5-16 5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 16 16)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon3-d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon3-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#icon3-b)",
    xlinkHref: "#icon3-a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon3-c)",
    mask: "url(#icon3-d)",
    d: "M16-6h20v38H16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon03);
export default __webpack_public_path__ + "static/media/icon-03.f73068ecc2e16f5c4d84e81b1a942604.svg";
export { ForwardRef as ReactComponent };